<picture *ngIf="imageBadgeName">
	<ng-container *ngIf="hasMobileAndDesktopImage">
		<source media="(max-width: 576px)" [srcset]="mobileImgBadge">
	</ng-container>
	<img alt="Product Badge" class="img-fluid" [src]="imgBadge" loading="lazy">
</picture>
